import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function ManualPage() {
  let navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleNavigateLogin = () => {
    navigate('../login');
  };

  const handleNavigateContactPage = () => {
    navigate('../contact');
  };

  const handleNavigateLandingPage = () => {
    navigate('../lp');
  };

  return (
    <>
      <nav className='navbar navbar-expand-lg bg-white fixed-top navbar-custom'>
        <div className='container-fluid flex-row-reverse'>
          <div className='col-2 text-center mx-auto' onClick={handleNavigateLandingPage}>
            <img src='/Sobol_logo.png' alt='Sobol Logo' height={'50px'} role={'button'} />
          </div>
          <div className='col text-start ms-2'>
            <div
              className='d-inline-block landing-page__button text-center py-2 me-3'
              onClick={handleNavigateLogin}
              role='button'>
              <span>{t('landingPage.contact.login')}</span>
            </div>
            <div
              className={`d-inline-block text-center py-2 ${
                i18n.language === 'ar' ? 'order-3' : 'order-1'
              }`}
              onClick={handleNavigateContactPage}>
              <span role={'button'}>{t('landingPage.contact.button')}</span>
            </div>
          </div>
        </div>
      </nav>

      <div className='mt-5 p-2'>
        <div className='p-2 my-4 text-end landing-page__first-section--title'>
          الفاتورة الإلكترونية – مصر
        </div>
        <div className='p-2 mb-5 fs-4 text-dark text-end landing-page__first-section--text'>
          الفيديوهات{' '}
        </div>
        <div className='row mx-1 p-1 mx-md-2 p-md-2 mx-lg-5 p-md-5'>
          <div className='col-10 offset-1 col-md-4 offset-md-8'>
            <div className='ratio ratio-16x9'>
              <iframe
                src='https://www.youtube.com/embed/nTa9BYEw0Hc'
                title='YouTube video player'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;'
                allowFullScreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ManualPage;
